import { api } from "../api";
import type { NoteSide } from "@glosor/shared";

export default function SideRenderer({ side, small = false }: { side: NoteSide; small?: boolean }) {
  return (
    <div className={small ? "space-y-1" : "space-y-3"}>
      {side.image && (
        <img
          src={api.imageUrl(side.image)}
          alt=""
          className={`mx-auto rounded-lg ${small ? "max-h-24" : "max-h-72"}`}
        />
      )}
      {side.text && (
        <div
          className={`whitespace-pre-wrap break-words text-center ${
            small ? "text-sm text-slate-700 dark:text-slate-300" : "text-2xl"
          }`}
        >
          {side.text}
        </div>
      )}
    </div>
  );
}
